// parts views
const PartsSpecType = () => import("Modules/manufacturing/parts/views/PartsSpecType");
const Parts = () => import("Modules/manufacturing/parts/views/Parts");
const PartProfile = () => import("Modules/manufacturing/parts/views/Profile");

// ROUTE OPTION - `pathToRegexpOptions: { strict: true }` makes trailing slashes fail to match path
export default {
    children: [
        {
            path: "parts",
            name: "parts",
            component: Parts,
            meta: {
                requiresAuth: true,
                title: "lang.parts",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["parts.read"],
            },
        },
        {
            path: "parts/:id(\\d+)/:tab?",
            name: "part_profile",
            component: PartProfile,
            meta: {
                requiresAuth: true,
                title: "lang.part_profile",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["parts.read"],
            },
        },
        {
            path: "configuration/parts_spec_type",
            name: "settings_parts_spec_type",
            component: PartsSpecType,
            meta: {
                requiresAuth: true,
                title: "lang.parts_spec_types",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["configuration.read"],
            },
        },
    ],
};
